import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FreeModeRateOption from './FreeModeRateOption';
import FreeModePaxSelector from './FreeModePaxSelector';
import FreeModeError from './FreeModeError';

import PictureSlider from '../rooms/PictureSlider';
import Quota from '../rooms/Quota';
import RoomRibbons from '../rooms/RoomRibbons';
import UserIcon from '../../icons/UserIcon';

import { getLangValue } from '../../../utils/Generic';

import { DEVICES, updateRatesForNewUse } from '../../../actions/Booking';

class FreeModeRoom extends React.Component {
  constructor(props) {
    super(props);
    const cheapestBoard = props.room.boardList[0];
    this.state = {
      selectedBoardCode: cheapestBoard.code,
      maxPaxList: Array.from(Array(props.room.max_pax)), // dummy list with one item per max pax allowed
      isOccupancyUpdating: false,
      showUpdateError: false,
    };
    this.onUseUpdated = this.onUseUpdated.bind(this);
    this.onSelectBoard = this.onSelectBoard.bind(this);
  }

  onSelectBoard(boardCode) {
    this.setState({ selectedBoardCode: boardCode });
  }

  onUseUpdated(updatedUse) {
    const submitOccupancy = {
      adults: updatedUse.adults,
      childs: updatedUse.childs,
      infants: updatedUse.infants,
      ages: updatedUse.ages || [], // we need to make sure that the ages field is filled on the room response!
    };
    this.setState({ isOccupancyUpdating: true, showUpdateError: false });
    this.props.dispatch(updateRatesForNewUse(this.props.room.code, submitOccupancy)).then((success) => {
      this.setState({ isOccupancyUpdating: false, showUpdateError: !success });
    });
  }

  isRoomInBasket() {
    return this.props.cartRooms.find((cartRoom) => cartRoom.room.code === this.props.room.code);
  }

  renderRateOptions() {
    const { roomOptions } = this.props.room;
    const visibleOptions = roomOptions.filter((roomOption) => roomOption.board.code === this.state.selectedBoardCode);
    //let visibleOptions = roomOptions.filter((roomOption) => roomOption.board.code === this.state.selectedBoardCode);

    // TEMA VisualicacionTarifasEnDiversasCurrenciesParaCallCenter
    // Se pidió que los usuarios de call center puedan filtrar por varias currencies
    // para ver visualmente los montos. Anteriormente cuando el usuario de call center
    // filtraba por algún currency, también con eso se seteaba ese currency como
    // el payment currency.
    // Pidieron que los usuarios de DIRECTOS CALL CENTER pudieran ver las tarifas en MXN, igual los de DIRECTOS CALL CENTER MÉXICO,
    // que puedan ver las tarifas en cualquier moneda, por lo que se comenta todo el siguiente if
    // Lo que hacía ese if, de alguna manera, es que si el hotel tiene custom_currency_rates, como los de México, y si la moneda filtrada
    // por el usuario es la misma que la custom currency rate, es decir, mxn, que sólo le aparezcan las tarifas en esa moneda, de alguna
    // manera eso no es muy útil, en realidad, la tarifa, si es DIRECTOS CALL CENTER, vendrá en USD y se puede mostrar el precio en
    // cualquier moneda filtrada por el usuario, si es DIRECTOS CALL CENTER MÉXICO, vendrá en MXN y se puede mostrar el precio en
    // cualquier moneda filtrada por el usuario, al final, la reserva se pagará en la moneda en la que venga la tarifa, por lo que
    // se decide comentar este siguiente if innecesario, de hecho así pidieron que funcionara ahora, por eso se comenta
    // al final, la reserva se cobrará en el currency en el
    // que venga el rate en el carrito, pero visualmente dejamos que el usuario filtre por la moneda que quiera
    // para que vea cuánto sería en su moneda que elija, pero al final se cobrará en la moneda en la que venga el rate
    // en el carrito, que es la que se obtuvo al hacer la búsqueda de disponibilidad
    /*
    if (this.props.requestInfo.has_custom_currency_rates) {
      if (this.props.filterCurrencyCode === this.props.requestInfo.custom_currency_code) {
        visibleOptions = visibleOptions.filter(
          (roomOption) => roomOption.rate.currency === this.props.requestInfo.custom_currency_code);
      } else {
        visibleOptions = visibleOptions.filter(
          (roomOption) => roomOption.rate.currency !== this.props.requestInfo.custom_currency_code);
      }
    }
    */
    return visibleOptions.map((rateOption) => (
              <FreeModeRateOption key={rateOption.optionId}
              rateOption={rateOption}
              checkMember={this.props.checkMember}/>
    ));
  }

  renderOccupancyUpdating() {
    if (this.state.showUpdateError) {
      return (
        <FreeModeError source="occupancyUpdate">
          <span className="h6 font-weight-bold">
            {this.context.t('There was an error updating the room occupancy')}:
          </span>
        </FreeModeError>
      );
    }
    if (!this.state.isOccupancyUpdating) {
      return false;
    }
    // The logos of the other chains are not round so can't use them with the spinning animation
    return (
      <div className="sandbox__loading">
        <img className="loading__img" src="/img/SANDOS_logo_sm.png" />
      </div>
    );
  }

  renderMaxOccupancy(room) {
    const maxPeopleText = this.context.t(['person', 'persons', 'n'], { n: room.max_pax });
    return (
      <div className="sandicon text-primary flex mb-1">
        {this.state.maxPaxList.map((el, index) => (<UserIcon key={`maxPax${index}`}/>))}
        <span className="ml-1">
          {this.context.t('Max.')} { room.max_pax } { maxPeopleText }
        </span>
      </div>
    );
  }

  renderSelectedBoardUnits(room, board) {
    const unitsInBasket = this.props.cartRooms.filter((cartRoom) => (
      cartRoom.room.code === room.code && cartRoom.board.code === board.code
    )).length;
    if (unitsInBasket === 0) {
      return null;
    }
    return (
      <small className="mx-1 text-cyan font-weight-normal text-lowercase">
        {this.context.t('{items} in basket', { items: unitsInBasket })}
      </small>
    );
  }

  renderBoards(room) {
    const radioClass = (board) => (
      `RadioSelect__item ${board.code === this.state.selectedBoardCode ? 'RadioSelect__item--selected' : ''}`
    );
    return room.boardList.map((board) => (
      <div key={board.code} className={radioClass(board)} onClick={() => { this.onSelectBoard(board.code); }}>
        <button className="RadioSelect__item-link">
          {getLangValue(board, this.props.lang, 'name')}
          {this.renderSelectedBoardUnits(room, board)}
        </button>
      </div>
    ));
  }

  getNewMemberDiscountPercentage() {
    //Regresa loyalty.newMemberDiscountPercentage
    //Si es 0, regresa this.props.new_member_discount_percentage ya que eso es igual a chain.Data.new_member_discount_percentage
    if (this.props.new_member_discount_percentage != null) {
      if (this.props.new_member_discount_percentage > 0) {
        return this.props.new_member_discount_percentage;
      }

      return this.props.new_member_discount_percentage_chain;
    }
    return this.props.new_member_discount_percentage_chain;
  }

  renderRoomRibbons(hotel, room, selectedBoard) {
    if (selectedBoard) {
      return (
              <RoomRibbons new_member_discount_percentage = {this.getNewMemberDiscountPercentage()}
              loyalty_name={this.props.loyalty_name}
              new_member_discount_percentage_activated = {this.props.new_member_discount_percentage_activated}
              new_member = {this.props.new_member}
              hotel={hotel} room={room} selectedBoard={selectedBoard} discountOnly
              membershipName = {(this.props.new_member_discount_percentage_activated && this.props.new_member)
                ? this.props.memberInfo.membershipName.toUpperCase() : ''}
              agentCode = {this.props.agentCode}
              agentSell = {this.props.agentSell}
              />
      );
    }
    return (<div></div>);
  }

  render() {
    const {
      hotel, room, isMobile, lang,
    } = this.props;
    const selectedClass = this.isRoomInBasket() ? 'FreeModeRoom--selected' : '';
    const selectedBoard = room.boardList.find((board) => board.code === this.state.selectedBoardCode);
    return (
      <div className={`FreeModeRoom sandbox my-3 ${selectedClass}`}>
        {this.renderOccupancyUpdating(hotel, room, selectedBoard)}
        <div className="row">
          <div className="col-xs-12 col-md-4">
            {this.renderRoomRibbons()}
            <PictureSlider key={`${room.code}_pictureSlider`} imageSize="sm" isMobile={isMobile}
                           photos={room.photos} onPictureClicked={this.props.onShowRoomPopUp} />
            <div onClick={this.props.onShowRoomPopUp} className="room-details see-more">
              {this.context.t('see details')}
            </div>
          </div>
          <div className="col-xs-12 col-md-8">
            <div className="font-weight-bold d-flex flex-wrap">
              <div className="room-name">
                {getLangValue(room, lang, 'name')}
              </div>
              <Quota quota={room.quota} showValue chain={this.props.chain} />
            </div>
            {this.renderMaxOccupancy(room)}
            <div className="RadioSelect">
              {this.renderBoards(room)}
            </div>
            <FreeModePaxSelector hotel={hotel} room={room} onOccupancyUpdate={this.onUseUpdated} lang={lang} />
            <div className="small mt-2 mb-3">
              {getLangValue(room, lang, 'description')}
            </div>
          </div>
        </div>
        {this.renderRateOptions()}
      </div>
    );
  }
}

FreeModeRoom.propTypes = {
  hotel: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  onShowRoomPopUp: PropTypes.func.isRequired,
  checkMember: PropTypes.func.isRequired,
};

FreeModeRoom.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
  hotel: state.booking.hotel,
  isMobile: state.booking.device === DEVICES.MOBILE,
  cartRooms: state.cart.cartHotel.rooms,
  requestInfo: state.booking.last_requested_info,
  filterCurrencyCode: state.booking.filterCurrency.code,
  currency: state.booking.filterCurrency,
  conversionRates: state.loyalty.conversionRates,
  memberInfo: state.loyalty.memberInfo,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  loyalty_name: state.session.chainData.loyalty_name,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
}))(FreeModeRoom);
